import {
    CREATE_PLAY_HISTORY_SUCCESS,
    CREATE_PLAY_HISTORY_ERROR,
    CREATE_PLAY_HISTORY_REQUEST,

    
    CREATE_PLAY_VIEW_HISTORY_SUCCESS,
    CREATE_PLAY_VIEW_HISTORY_ERROR,
    CREATE_PLAY_VIEW_HISTORY_REQUEST
} from '../../Types/user/Types'

const initialState = {
    error: "",
    create_play_history_data: "",
    create_play_view_history_data:"",
    isChatDocument: false,
    loader: false,
  };

  export const create_play_history_Reducer = (state = initialState, action) => {
    switch (action.type) {
      case CREATE_PLAY_HISTORY_SUCCESS:
        return {
          ...initialState.create_play_history_data,
          error: "",
          create_play_history_data: action.payload,
          loader: false,
        };
      case CREATE_PLAY_HISTORY_ERROR:
        return {
          ...initialState.create_play_history_data,
          error: action.error,
          create_play_history_data: "",
          loader: false,
        };
      case  CREATE_PLAY_HISTORY_REQUEST:
        return {
          ...initialState.create_play_history_data,
          error: null,
          create_play_history_data: action.payload,
          loader: true,
        };
      default:
        return state;
    }
  };



  export const create_play_view_history_Reducer = (state = initialState, action) => {
    switch (action.type) {
      case CREATE_PLAY_VIEW_HISTORY_SUCCESS:
        return {
          ...initialState.create_play_view_history_data,
          error: "",
          create_play_view_history_data: action.payload,
          loader: false,
        };
      case CREATE_PLAY_VIEW_HISTORY_ERROR:
        return {
          ...initialState.create_play_view_history_data,
          error: action.error,
          create_play_view_history_data: "",
          loader: false,
        };
      case  CREATE_PLAY_VIEW_HISTORY_REQUEST:
        return {
          ...initialState.create_play_view_history_data,
          error: null,
          create_play_view_history_data: action.payload,
          loader: true,
        };
      default:
        return state;
    }
  };

  export const chatDocumentReducer = (state = initialState, action) => {
    switch (action.type) {
      case 'SET_CHAT_DOCUMENT':
        return {
          ...state,
          isChatDocument: action.payload,
        };
      default:
        return state;
    }
  };


  